export default function ({ ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
            <g clipPath="url(#clip0_10494_12129)">
                <path
                    d="M56 44.9618V27.0381C55.9992 26.2524 55.7935 25.4806 55.4034 24.8003C55.0134 24.12 54.4528 23.555 53.7778 23.1621L38.2222 14.2003C37.5466 13.807 36.7802 13.6 36 13.6C35.2198 13.6 34.4534 13.807 33.7778 14.2003L18.2222 23.1621C17.5473 23.555 16.9866 24.12 16.5966 24.8003C16.2065 25.4806 16.0008 26.2524 16 27.0381V44.9618C16.0008 45.7476 16.2065 46.5194 16.5966 47.1997C16.9866 47.88 17.5473 48.4449 18.2222 48.8378L33.7778 57.7996C34.4534 58.1929 35.2198 58.4 36 58.4C36.7802 58.4 37.5466 58.1929 38.2222 57.7996L53.7778 48.8378C54.4528 48.4449 55.0134 47.88 55.4034 47.1997C55.7935 46.5194 55.9992 45.7476 56 44.9618Z"
                    stroke="#03060B"
                    strokeWidth="3.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16.7988 24.8L35.9988 36L55.1988 24.8" stroke="#03060B" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M36 58.4V36" stroke="#03060B" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M29.137 18.4L47.23 29.0062C47.9741 29.4569 48.2221 30.4426 47.7838 31.2078C47.3455 31.973 46.3869 32.228 45.6427 31.7773L26.4004 20.008L29.137 18.4Z"
                    fill="#2164FF"
                />
                <path d="M46.4004 30.4V41.6" stroke="#2164FF" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_10494_12129">
                    <rect width="72" height="72" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
